export class GroupModelsDto {
  groupId: number;
  instanceId: string;
  read: boolean;
  write: boolean;
}
